import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import ClassView from '../pages/class/Index'
import Division from '../pages/division/Index'
import Trip from '../pages/trip/Index'
import Stay from '../pages/stay/Index'
import Bus from '../pages/bus/Index'
import Student from '../pages/student/Index'
import Driver from '../pages/driver/Index'
import Staff from '../pages/staff/Index'
import Shift from '../pages/shift/Index'
import Roots from '../pages/roots/Index'
import SchoolProfilePage from '../pages/profile/Index'
import LiveTrip from '../pages/liveTrip/Index'
import Holiday from '../pages/holiday/Index'
import MsgBroadcast from '../pages/msg-broadcast/Index'
import BusLiveLocation from '../pages/busLiveLocation/Index'
import TripHistory from '../pages/trip-history/Index'
import Guardian from '../pages/guardian/Index'
import BusBrand from '../pages/busBrand/Index'
import TripNumber from '../pages/tripNumber/Index'
import BusAttendee from '../pages/conductor/Index'
import Security from '../pages/security/Index'
import TransportAdmin from '../pages/transport-admin/Index'
import TeamLeader from '../pages/team-leader/Index'
import Banner from '../pages/banner/Index'
import InspectionReport from '../pages/inspectionReport/Index'
import FleetReport from '../pages/fleetReport/Index'
import StudentAttendanceReport from '../pages/studentAttendanceReport/Index'
import DriverLicenseStatusReport from '../pages/driverLicenseStatusReport/Index'
import RouteReport from '../pages/RouteReport/Index'
import DriverLoginReport from '../pages/DriverLoginReport/Index'
import VehicleMovementReport from '../pages/VehicleMovementReport/Index'
import TripNotStartedReport from '../pages/TripNotStartedReport/Index'


const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  // const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // const Holiday = lazy(() => import('../pages/holiday/Index'))
  const EventCalendar = lazy(() => import('../pages/event-calendar/Index'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to="/dashboard" />} />
        {/* Pages */}
        <Route path="dashboard" element={<DashboardWrapper />} />
        {/* <Route path="builder" element={<BuilderPageWrapper />} /> */}
        <Route path="school-management/class" element={<ClassView />} />
        <Route path="school-management/division" element={<Division />} />
        <Route path="school-management/shift" element={<Shift />} />
        <Route path="school-management/bus" element={<Bus />} />
        <Route path="school-management/all-bus-brand" element={<BusBrand />} />
        <Route path="trip/all-trip-list" element={<Trip />} />
        <Route path="stay/all-stay-list" element={<Stay />} />
        <Route path="trip/all-trip-numbers" element={<TripNumber />} />
        {/* <Route path="trip/upload" element={<TripUpload />} /> */}
        <Route path="trip/trip-history" element={<TripHistory />} />
        <Route path="trip/live-trip" element={<LiveTrip />} />
        <Route path="trip/track-bus" element={<BusLiveLocation />} />
        <Route path="school-management/routes" element={<Roots />} />
        <Route path="school-management/holidays" element={<Holiday />} />
        <Route path="school-management/banner" element={<Banner />} />
        <Route path="users/driver" element={<Driver />} />
        <Route path="users/student" element={<Student />} />
        <Route path="users/staff" element={<Staff />} />
        {/* <Route path="users/upload-student" element={<StudentUpload />} /> */}
        {/* <Route path="users/upload-nfc" element={<NFCUpload />} /> */}
        <Route path="users/guardians" element={<Guardian />} />
        <Route path="users/conductors" element={<BusAttendee />} />
        <Route path="users/security" element={<Security />} />
        <Route path="users/team-leader" element={<TeamLeader />} />
        <Route path="users/transport-admin" element={<TransportAdmin />} />
        <Route path="broadcast" element={<MsgBroadcast />} />
        <Route path="inspection-report" element={<InspectionReport />} />
        <Route path="fleet-report" element={<FleetReport />} />
        <Route path="student-attendance-report" element={<StudentAttendanceReport />} />
        <Route path="driver-license-report" element={<DriverLicenseStatusReport />} />
        <Route path="route-report" element={<RouteReport />} />
        <Route path="driver-login-report" element={<DriverLoginReport />} />
        <Route path="vehicle-movement-report" element={<VehicleMovementReport />} />
        <Route path="trip-not-started-report" element={<TripNotStartedReport />} />
        {/* Lazy Modules */}
        <Route
          path="profile/*"
          element={
            <SuspensedView>
              <SchoolProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path="event-calendar"
          element={
            <SuspensedView>
              <EventCalendar />
            </SuspensedView>
          }
        />
        <Route
          path="crafted/pages/profile/*"
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        {/* <Route
          path="crafted/pages/wizards/*"
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path="crafted/widgets/*"
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path="crafted/account/*"
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path="apps/chat/*"
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        /> */}
        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 3,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
